import {useMutation, useQuery} from '@tanstack/react-query';
import {
  analyzeSearch,
  getSearchTree,
  getRedationHistory,
  preRedactionReportDownload,
  getAnalysisResult,
  batchredaction,
  getRedactionRollback,
  postBatchRedactionReport,
} from '../../api/endpoints/redactionApi';
import {
  ISearchTreeResponse,
  IRedactionHistoryResponse,
  IRedactionHistoryRequest,
  IPreRedactionReportPayload,
  IBatchRedactionRequest,
  IBatchRedactionRollbackResponse,
  IBatchRedactionRollbackPayload,
  IActionMessageResponse,
  IBatchRedactionReportRequest,
} from '../../api/types/redactions.type';

export const useGetSearchTreeData = () => {
  return useQuery<Array<ISearchTreeResponse>, Error>({
    queryKey: ['searchTree'],
    queryFn: () => getSearchTree(),
  });
};

export const useAnalyzeSearch = (
  onSuccess?: (success: any) => void,
  onError?: (err: Error) => void
) => {
  return useMutation({
    mutationFn: analyzeSearch,
    onSuccess: (success) => {
      onSuccess?.(success);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetRedactionHistory = (payload: IRedactionHistoryRequest) => {
  return useQuery<IRedactionHistoryResponse, Error>({
    queryKey: ['redactionHistory', payload],
    queryFn: () => getRedationHistory(payload),
    staleTime: 1000,
  });
};

export const useGetAnalysisResult = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation({
    mutationFn: (idList: string[]) => getAnalysisResult(idList),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const usePreRedactionReportDownload = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation({
    mutationFn: (payload: IPreRedactionReportPayload) =>
      preRedactionReportDownload(payload),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useBatchRedaction = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation({
    mutationFn: (payload: IBatchRedactionRequest) => batchredaction(payload),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useBatchRedactionRollback = () => {
  return useMutation<
    IBatchRedactionRollbackResponse,
    Error,
    IBatchRedactionRollbackPayload
  >({
    mutationFn: getRedactionRollback,
  });
};

export const useBatchRedactionReport = () => {
  return useMutation<
    IActionMessageResponse,
    Error,
    IBatchRedactionReportRequest
  >({
    mutationFn: postBatchRedactionReport,
  });
};
